import cn from "classnames";
import type { PropsWithChildren } from "react";
import styles from "./Badge.module.css";

interface BadgeProps extends PropsWithChildren {
	variant?: "primary" | "green";
}

export function Badge(props: BadgeProps) {
	const { variant = "primary", ...rest } = props;

	return (
		<span
			className={cn(styles.badge, {
				[styles.badgePrimary]: variant === "primary",
				[styles.badgeGreen]: variant === "green",
			})}
			{...rest}
		/>
	);
}
